export const products = [
  // --- Handmade Pottery ---
  {
    id: 'pottery_1',
    name: 'Handcrafted Ceramic Vase',
    price: 45.99,
    description: 'Beautiful hand-thrown ceramic vase with unique glazing, perfect for home decor.',
    category: 'pottery',
    image: 'https://placehold.co/600x400/4B0082/FFFFFF/png?font=montserrat&text=Pottery+%7C+Vase', // Indigo/White with better contrast
    rating: 4.8,
    reviews: 89,
    inStock: true
  },
  {
    id: 'pottery_2',
    name: 'Stoneware Dinner Set',
    price: 129.99,
    description: 'Complete 16-piece stoneware dinner set with elegant hand-painted designs.',
    category: 'pottery',
    image: 'https://placehold.co/600x400/6A5ACD/FFFFFF/png?font=montserrat&text=Dinner+Set+%7C+16pcs', // Slate Blue/White with better contrast
    rating: 4.9,
    reviews: 142,
    inStock: true
  },
  {
    id: 'pottery_3',
    name: 'Artisan Tea Set',
    price: 89.99,
    description: 'Traditional handcrafted tea set with 6 cups and teapot, perfect for tea ceremonies.',
    category: 'pottery',
    image: 'https://placehold.co/600x400/9370DB/FFFFFF/png?font=montserrat&text=Tea+Set+%7C+Handcrafted', // Medium Purple/White with better contrast
    rating: 4.7,
    reviews: 67,
    inStock: true
  },

  // --- Textiles & Weaving ---
  {
    id: 'textile_1',
    name: 'Handwoven Cotton Throw Blanket',
    price: 79.99,
    description: 'Luxurious handwoven cotton throw blanket with traditional patterns.',
    category: 'textiles',
    image: 'https://placehold.co/600x400/008B8B/FFFFFF/png?font=montserrat&text=Luxury+Throw+Blanket', // Dark Cyan/White with better contrast
    rating: 4.7,
    reviews: 203,
    inStock: true
  },
  {
    id: 'textile_2',
    name: 'Embroidered Silk Scarf',
    price: 54.99,
    description: 'Elegant hand-embroidered silk scarf with intricate patterns.',
    category: 'textiles',
    image: 'https://placehold.co/600x400/48D1CC/FFFFFF/png?font=montserrat&text=Silk+Scarf+%7C+Hand-Embroidered', // Medium Turquoise/White with better contrast
    rating: 4.8,
    reviews: 156,
    inStock: true
  },
  {
    id: 'textile_3',
    name: 'Traditional Wall Hanging',
    price: 119.99,
    description: 'Hand-woven wall hanging with tribal patterns and natural dyes.',
    category: 'textiles',
    image: 'https://placehold.co/600x400/20B2AA/FFFFFF/png?font=montserrat&text=Wall+Hanging+%7C+Handwoven', // Light Sea Green/White with better contrast
    rating: 4.9,
    reviews: 78,
    inStock: true
  },

  // --- Woodworking ---
  {
    id: 'wood_1',
    name: 'Handcarved Wooden Bowl',
    price: 67.99,
    description: 'Beautiful handcarved wooden bowl made from sustainable oak wood.',
    category: 'woodworking',
    image: 'https://placehold.co/600x400/8B4513/FFFFFF/png?font=montserrat&text=Handcarved+Wooden+Bowl', // Saddle Brown/White with better contrast
    rating: 4.6,
    reviews: 124,
    inStock: true
  },
  {
    id: 'wood_2',
    name: 'Artisan Wooden Jewelry Box',
    price: 89.99,
    description: 'Handcrafted wooden jewelry box with intricate carvings and brass fittings.',
    category: 'woodworking',
    image: 'https://placehold.co/600x400/A0522D/FFFFFF/png?font=montserrat&text=Artisan+Jewelry+Box', // Sienna/White with better contrast
    rating: 4.8,
    reviews: 92,
    inStock: true
  },
  {
    id: 'wood_3',
    name: 'Traditional Wooden Spoons Set',
    price: 34.99,
    description: 'Set of 6 handcrafted wooden spoons with unique designs.',
    category: 'woodworking',
    image: 'https://placehold.co/600x400/CD853F/FFFFFF/png?font=montserrat&text=Wooden+Utensils+Set', // Peru/White with better contrast
    rating: 4.5,
    reviews: 167,
    inStock: true
  },

  // --- Jewelry & Accessories ---
  {
    id: 'jewelry_1',
    name: 'Handmade Silver Earrings',
    price: 42.99,
    description: 'Elegant handcrafted silver earrings with natural gemstones.',
    category: 'jewelry',
    image: 'https://placehold.co/600x400/D3D3D3/000000/png?font=montserrat&text=Sterling+Silver+Earrings', // Light Gray/Black with better contrast
    rating: 4.7,
    reviews: 234,
    inStock: true
  },
  {
    id: 'jewelry_2',
    name: 'Beaded Bracelet Set',
    price: 28.99,
    description: 'Hand-beaded bracelet set with traditional patterns and natural stones.',
    category: 'jewelry',
    image: 'https://placehold.co/600x400/808080/000000/png?font=montserrat&text=Hand-Beaded+Bracelet+Set', // Gray/Black with better contrast
    rating: 4.6,
    reviews: 189,
    inStock: true
  },
  {
    id: 'jewelry_3',
    name: 'Artisan Copper Necklace',
    price: 56.99,
    description: 'Handcrafted copper necklace with intricate wirework and pendant.',
    category: 'jewelry',
    image: 'https://placehold.co/600x400/CD7F32/FFFFFF/png?font=montserrat&text=Handcrafted+Copper+Necklace', // Bronze/White with better contrast
    rating: 4.8,
    reviews: 145,
    inStock: true
  },

  // --- Paper Crafts ---
  {
    id: 'paper_1',
    name: 'Handmade Paper Journal',
    price: 24.99,
    description: 'Beautiful handmade paper journal with leather cover and deckle edges.',
    category: 'paper',
    image: 'https://placehold.co/600x400/FF6347/000000/png?font=montserrat&text=Handmade+Leather+Journal', // Tomato/Black with better contrast
    rating: 4.5,
    reviews: 98,
    inStock: true
  },
  {
    id: 'paper_2',
    name: 'Origami Art Set',
    price: 19.99,
    description: 'Set of hand-folded origami pieces in traditional Japanese designs.',
    category: 'paper',
    image: 'https://placehold.co/600x400/FF8C00/000000/png?font=montserrat&text=Origami+Art+Collection', // Dark Orange/Black with better contrast
    rating: 4.4,
    reviews: 76,
    inStock: true
  },

  // --- Glass Crafts ---
  {
    id: 'glass_1',
    name: 'Handblown Glass Vase',
    price: 94.99,
    description: 'Stunning handblown glass vase with unique color patterns.',
    category: 'glass',
    image: 'https://placehold.co/600x400/0000CD/FFFFFF/png?font=montserrat&text=Handblown+Glass+Vase', // Medium Blue/White with better contrast
    rating: 4.9,
    reviews: 112,
    inStock: true
  },
  {
    id: 'glass_2',
    name: 'Stained Glass Panel',
    price: 149.99,
    description: 'Beautiful stained glass panel with intricate floral design.',
    category: 'glass',
    image: 'https://placehold.co/600x400/4169E1/FFFFFF/png?font=montserrat&text=Stained+Glass+Panel', // Royal Blue/White with better contrast
    rating: 4.8,
    reviews: 87,
    inStock: true
  },

  // --- Metal Crafts ---
  {
    id: 'metal_1',
    name: 'Wrought Iron Wall Decor',
    price: 78.99,
    description: 'Hand-forged wrought iron wall decor with scroll patterns.',
    category: 'metal',
    image: 'https://placehold.co/600x400/2F4F4F/FFFFFF/png?font=montserrat&text=Wrought+Iron+Wall+Art', // Dark Slate Gray/White with better contrast
    rating: 4.6,
    reviews: 134,
    inStock: true
  },
  {
    id: 'metal_2',
    name: 'Brass Candle Holders',
    price: 45.99,
    description: 'Set of 2 handcrafted brass candle holders with traditional designs.',
    category: 'metal',
    image: 'https://placehold.co/600x400/483D8B/FFFFFF/png?font=montserrat&text=Handcrafted+Brass+Holders', // Dark Slate Blue/White with better contrast
    rating: 4.7,
    reviews: 98,
    inStock: true
  },

  // --- Basket Weaving ---
  {
    id: 'basket_1',
    name: 'Handwoven Storage Basket',
    price: 39.99,
    description: 'Traditional handwoven basket made from natural seagrass.',
    category: 'baskets',
    image: 'https://placehold.co/600x400/B8860B/FFFFFF/png?font=montserrat&text=Handwoven+Storage+Basket', // Dark Goldenrod/White with better contrast
    rating: 4.5,
    reviews: 167,
    inStock: true
  },
  {
    id: 'basket_2',
    name: 'Picnic Basket Set',
    price: 67.99,
    description: 'Handcrafted picnic basket with lid and traditional weaving patterns.',
    category: 'baskets',
    image: 'https://placehold.co/600x400/DAA520/FFFFFF/png?font=montserrat&text=Premium+Picnic+Basket+Set', // Goldenrod/White with better contrast
    rating: 4.6,
    reviews: 89,
    inStock: true
  }
];

export const featuredProducts = [
  'pottery_1',
  'textile_1',
  'wood_1',
  'jewelry_1',
  'glass_1',
  'metal_1'
];